<header
  id="dashboard-header"
  class="header-area bg-white border-bottom-radius box-shadow mb-25 sticky-header"
  [ngClass]="{ active: isToggled, sticky: true }"
  [class.component-dark-theme]="themeService.isDark()"
  [class.right-sidebar]="themeService.isRightSidebar()"
  [class.hide-sidebar]="themeService.isHideSidebar()"
  [class.dark-header]="themeService.isHeaderDark()"
  [class.card-bordered-theme]="themeService.isCardBorder()"
  [class.card-border-radius]="themeService.isCardBorderRadius()"
  [class.rtl-enabled]="themeService.isRTLEnabled()"
>
  <div
    class="status-bar"
    [ngClass]="status === onlineStatusCheck.ONLINE ? 'online' : 'offline'"
  ></div>
  <div
    *ngIf="status === onlineStatusCheck.OFFLINE"
    class="offline-banner"
    role="status"
    aria-live="polite"
  >
    <i class="ri-wifi-off-line"></i>
    <span>You’re offline. Some actions may be unavailable.</span>
    <button
      type="button"
      class="retry-btn border-none"
      (click)="toggleConnectionStatus()"
    >
      Retry
    </button>
  </div>
  <div class="d-md-flex align-items-center justify-content-space-between">
    <div class="header-left-side d-flex align-items-center">
      <div
        class="burger-menu"
        (click)="toggle()"
        [ngClass]="{ active: isToggled }"
      >
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
      </div>
      <!-- <form class="search-box position-relative">
        <input type="text" class="input-search d-block" placeholder="Search here.." />
        <button type="submit"><i class="ri-search-line"></i></button>
      </form> -->
    </div>
    <ul class="header-right-side d-flex align-items-center mt-0 mb-0">
      <li>
        <button
          mat-icon-button
          class="btn p-0 border-none rounded-circle position-relative notification-btn me-10"
          matBadgePosition="above after"
          matBadgeColor="success"
          matBadgeSize="medium"
          (click)="tourUiService.resolveRoutePattern()"
        >
          <i class="ri-question-line"></i>
        </button>
        <button
          mat-icon-button
          [matMenuTriggerFor]="notificationMenu"
          class="btn p-0 border-none rounded-circle position-relative notification-btn me-10"
          [matBadge]="
            notificationCount > 0
              ? notificationCount > 99
                ? '99+'
                : notificationCount
              : null
          "
          matBadgePosition="above after"
          matBadgeColor="warn"
          matBadgeSize="medium"
          *ngIf="notificationCount !== undefined && notificationCount !== null"
        >
          <i class="flaticon-bell-2"></i>
        </button>
        <button
          mat-icon-button
          class="btn p-0 border-none rounded-circle position-relative status-btn me-10"
          [ngClass]="status === onlineStatusCheck.ONLINE ? 'online' : 'offline'"
          [attr.title]="
            status === onlineStatusCheck.ONLINE ? 'Online' : 'Offline'
          "
          (click)="toggleConnectionStatus()"
        >
          <i
            class="ri-wifi-line"
            *ngIf="status === onlineStatusCheck.ONLINE"
          ></i>
          <i
            class="ri-wifi-off-line"
            *ngIf="status === onlineStatusCheck.OFFLINE"
          ></i>
        </button>
        <!-- <span class="status-text" [ngClass]="status === onlineStatusCheck.ONLINE ? 'online' : 'offline'">
          {{ status === onlineStatusCheck.ONLINE ? 'Online' : 'Offline' }}
        </span> -->
        <mat-menu
          class="menu-dropdown"
          #notificationMenu="matMenu"
          xPosition="before"
        >
          <div
            class="menu-header d-flex align-items-center justify-content-space-between"
          >
            <h5 class="m-0">{{ "notifications.capitalize" | translate }}</h5>
            <button type="button" class="bg-transparent p-0 border-none">
              {{ "mark_all_as_read.capitalize" | translate }}
            </button>
          </div>
          <ul class="menu-body">
            @for (notification of notifications; track notification.id) {
              <li class="position-relative">
                <div class="d-flex">
                  <i class="flaticon-file-1 icon"></i>
                  <div class="title">
                    <h6>{{ notification.message }}</h6>
                    <span
                      ><i class="flaticon-timer"></i>
                      {{ notification.timestamp }}</span
                    >
                  </div>
                </div>
                <a [routerLink]="ROUTES.NOTIFICATIONS" class="link-btn"></a>
              </li>
            }
          </ul>

          <div class="menu-footer">
            <a
              [routerLink]="ROUTES.NOTIFICATIONS"
              class="fw-medium position-relative"
              >{{ "view_all.titlecase" | translate }}
              <i class="flaticon-chevron"></i
            ></a>
          </div>
        </mat-menu>
      </li>
      <li class="language-area">
        <button
          mat-icon-button
          [matMenuTriggerFor]="languageMenu"
          class="language-btn n p-0 border-none rounded-circle position-relative"
        >
          {{ i18nService.language.toUpperCase() }}
        </button>
        <mat-menu
          class="language-menu-dropdown"
          #languageMenu="matMenu"
          xPosition="after"
        >
          <ul class="m-0">
            @for (language of supportedLanguages; track language) {
              <li>
                <button
                  (click)="switchLanguage(language.code)"
                  type="button"
                  class="d-flex align-items-center border-none"
                >
                  {{ language.code.toUpperCase() }}
                </button>
              </li>
            }
          </ul>
        </mat-menu>
      </li>
      <li>
        <button
          mat-icon-button
          [matMenuTriggerFor]="profileMenu"
          class="profile-btn main-color border-none bg-transparent position-relative"
        >
          <img src="assets/img/admin.jpg" class="rounded-circle" alt="admin" />
          <span class="fw-semibold">{{
            userProfile?.firstName?.split(" ")[0] ??
              userProfile?.fullName?.split(" ")[0] ??
              "User"
          }}</span>
        </button>
        <mat-menu
          class="profile-menu-dropdown"
          #profileMenu="matMenu"
          xPosition="before"
        >
          <ul class="m-0">
            @if (!isNumber) {
              <li>
                <a [routerLink]="['/', ROUTES.PROFILE, userType.toLowerCase()]">
                  <i class="ri-user-3-line"></i>
                  {{ "profile.capitalize" | translate }}
                </a>
              </li>
            } @else {
              <li>
                <a
                  [routerLink]="[
                    '/',
                    ROUTES.PROFILE,
                    userTypes[userType].toLowerCase(),
                  ]"
                >
                  <i class="ri-user-3-line"></i>
                  {{ "profile.capitalize" | translate }}
                </a>
              </li>
            }
            <li>
              <a (click)="MsLogout()" style="cursor: pointer">
                <i class="ri-shut-down-line"></i>
                {{ "logout.capitalize" | translate }}
              </a>
            </li>
          </ul>
        </mat-menu>
      </li>
    </ul>
  </div>
</header>
